module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume_pc/icon_help-a755ce030959beaecc6d0ca7ad02be2f.png";